// @flow

import {Http} from './http';
import {providerUrlV2 as _providerUrlV2, usersProviderV2 as _usersProviderV2} from './config';
import {Logger} from './logger';

const LIVE_EMBED_LENGTH = 8;
const VOD_EMBED_LENGTH = 10;

/**
 * Resuelve con qué versión del proveedor de JSON hay que servir el player.
 *
 * El usuario no viaja en la url, así que se pregunta a la v2 sólo para conocerlo: el player en
 * live y el vídeo en vod, porque los embeds de 10 caracteres de la v1 no existen como playerKey
 * en la v2. Si el usuario está migrado se sirve con la v2; si no, o si la v2 falla, con la v1.
 *
 * @param {any} config configuración de entrada del player
 * @returns {Promise<{version: number, playerData: any}>} versión a usar
 */
export async function resolveProviderVersion(config: any): Promise<any> {
  const logger = new Logger('providerVersion');
  const forced = parseInt(config.providerVersion);
  if (forced === 1 || forced === 2) return {version: forced, playerData: null};

  const embed = config.embed;
  // Una url sólo con el guid del vod es de la v2.
  if ((embed === undefined || embed === null || !embed.length) && config.id) return {version: 2, playerData: null};

  const apiUrl = config.providerUrlV2 !== undefined && config.providerUrlV2 ? config.providerUrlV2 : _providerUrlV2;
  const users = (config.usersProviderV2 !== undefined && config.usersProviderV2 ? config.usersProviderV2 : _usersProviderV2).map(u =>
    String(u).toLowerCase()
  );

  let probeUrl = null;
  if (embed.length === LIVE_EMBED_LENGTH) probeUrl = `${apiUrl}/json/player/${embed}`;
  else if (embed.length === VOD_EMBED_LENGTH && config.id) probeUrl = `${apiUrl}/json/video/${config.id}`;
  if (!probeUrl) return {version: 1, playerData: null};

  let data = null;
  try {
    data = await Http.execute(probeUrl, null, 'GET');
  } catch (e) {
    logger.debug('v2 probe failed, using v1', e);
    return {version: 1, playerData: null};
  }

  const user = data !== undefined && data && data.user ? String(data.user).toLowerCase() : null;
  if (user && users.indexOf(user) > -1) return {version: 2, playerData: null};
  return {version: 1, playerData: null};
}
